module.exports = __webpack_public_path__ + "static/promocje-7114a12ad2288a16e999003b82e21379.png";